import {_delete, _get, _post, _put} from "@api/services/httpService";

export const URI_SUBSCRIPTION_PLAN = "/clubs/subscription-plans";

export const getSubscriptionPlans = (clubId, enabled) => {
  let url = URI_SUBSCRIPTION_PLAN + '?club.id=' + clubId;

  if ("undefined" === typeof enabled) {
    url += '&enabled=true';
  } else {
    if (null !== enabled) {
      url += '&enabled=' + enabled;
    }
  }

  return _get(url);
}

export const postSubscriptionPlan = (subscriptionPlan) => _post(URI_SUBSCRIPTION_PLAN, subscriptionPlan);

export const getSubscriptionPlan = (id) => _get(URI_SUBSCRIPTION_PLAN + '/' + id);

export const putSubscriptionPlan = (id, data) => _put(URI_SUBSCRIPTION_PLAN + '/' + id, data);

export const deleteSubscriptionPlan = (id) => _delete(URI_SUBSCRIPTION_PLAN + '/' + id);
